import { CreditorState } from '@debbie/common/dist/creditor/index.js'
import { useAllCreditors } from '@debbie/cortex/dist/creditors/index.js'
import { h } from '@debbie/cortex/dist/index.js'
import { RootState } from '@debbie/cortex/dist/reducer.js'
import { Row } from '@debbie/iris/dist/components/Grid/index.js'
import {
  Button,
  Content,
  PageBase,
  SubMenu,
  TopNav,
} from '@debbie/iris/dist/components/index.js'
import React from 'react'
import { useSelector } from 'react-redux'

import Dashboard from '../components/Dashboard.js'

const Home = () => {
  const allCreditorsLoadable = useAllCreditors()
  const allCreditors = h.hasData(allCreditorsLoadable)
    ? allCreditorsLoadable.data
    : null
  const lang = useSelector((s: RootState) => s.lang)
  const selectedCreditor = useSelector((s: RootState) => s.selectedCreditor)

  const creditor = allCreditors
    ? allCreditors.find((creditor) => creditor.creditorId === selectedCreditor)
    : null

  return (
    <div>
      <TopNav />
      <Content withSubMenu>
        <PageBase>
          <SubMenu
            items={[
              {
                text: lang.navigation.overview,
                link: '/',
              },
              {
                text: lang.navigation.cases,
                link: '/cases',
              },
            ]}
          >
            <div
              style={{
                display: 'inline-block',
                verticalAlign: 'bottom',
              }}
            >
              {selectedCreditor && creditor && (
                <>
                  <div
                    data-tooltip-content={
                      creditor.state === CreditorState.Ceased
                        ? lang.cases.missingCreateAccess
                        : null
                    }
                    data-tooltip-id="tooltip-left"
                  >
                    <Button
                      size="small"
                      disabled={creditor.state === CreditorState.Ceased}
                      href="/create-case"
                    >
                      {lang.cases.createNewCase}
                    </Button>
                  </div>
                </>
              )}
            </div>
          </SubMenu>
          <Row>
            <Dashboard />
          </Row>
        </PageBase>
      </Content>
    </div>
  )
}

export default Home
